import PageNotFoundComponent from '../components/PageNotFoundComponent'

const PageNotFound = () => {
  return (
    <>
        <PageNotFoundComponent />
    </>
  )
}

export default PageNotFound